import React from "react";

import svg from "../../assets/images/icons/download.svg";

export const DownloadIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Download"}
    />
);
